module.exports = __webpack_public_path__ + "img/lufthansa-logo.7a59a137.png";